import { useMemo } from 'react';

import { FilterOptions } from '../constants';

export function useFilterOptions(wells) {
  return useMemo(() => {
    if (!wells) return [];

    return FilterOptions.map(({ value, label }) => {
      const uniqueValues = new Set();
      wells.forEach(well => {
        if (well[value] !== 'Null') uniqueValues.add(well[value]);
      });

      return {
        value,
        label,
        options: [...uniqueValues].sort().concat(['Null']),
      };
    });
  }, [wells]);
}
